<template>
  <transition
    enter-active-class="transition duration-300 ease-out transform"
    enter-from-class="-translate-x-5 opacity-0"
    enter-to-class="translate-x-0 opacity-100"
    leave-active-class="transition duration-300 ease-in transform"
    leave-from-class="translate-x-0 opacity-100"
    leave-to-class="translate-x-5 opacity-0"
  >
    <div
      v-if="show"
      class="p-4 my-2 rounded-md"
      :class="{
        'bg-brand-red': message.tag === 'error',
        'bg-brand-green': message.tag !== 'error',
      }"
    >
      <div class="flex items-center">
        <div class="self-start shrink-0">
          <CheckCircleIcon v-if="message.tag !== 'error'" class="w-5 h-5 mt-1 text-white" aria-hidden="true" />
          <ExclamationIcon v-else class="w-5 h-5 mt-1 text-white" aria-hidden="true" />
        </div>
        <div class="ml-3">
          <p class="text-sm font-semibold break-words text-white text-body">
            {{ message.text }}
          </p>
        </div>
        <div class="self-start pl-3 mt-1 ml-auto">
          <div class="-mx-1.5 -my-1.5">
            <button
              @click="show = false"
              type="button"
              :class="{'text-brand-green': message.tag !== 'error', 'text-brand-red': message.tag === 'error'}"
              class="
                inline-flex
                bg-white
                rounded-md
                p-1.5
                focus:outline-none
                hover:opacity-90
                transition-all
                duration-100
              "
            >
              <span class="sr-only">Dismiss</span>
              <XIcon class="w-5 h-5" aria-hidden="true" />
            </button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { CheckCircleIcon, XIcon, ExclamationIcon } from "@heroicons/vue/solid";

export default {
  components: {
    CheckCircleIcon,
    XIcon,
    ExclamationIcon,
  },

  props: {
    message: {
      type: Object,
    },
  },

  data() {
    return {
      show: true,
    };
  },

  mounted() {
    // setTimeout(() => {
    //   this.show = false;
    // }, 5000);
  },
};
</script>

<style>
</style>
